import MetaDataProivder from '../../Components/MetaDataProvider';
import MainTemplate from '../../Template/MainTemplate';
import { Col, Container, Row } from 'react-bootstrap';
import { Trans, useTranslation } from "react-i18next";
import { toPng } from 'html-to-image';

import heroImage from "../../Assets/img/accessibility-checker-hero.svg";
import LodingImg from "../../Assets/img/icon-spinner.svg";

import ScanURLFormComponents from '../../Components/ScanURLForm';

import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreProptypes } from '../../PropTypes/StoreProptypes';
import { ScanningProcessService } from '../../Services/ScanningProcessService';
import { Link, useSearchParams } from 'react-router-dom';
import WebsiteURLSection from '../../Components/ScanDetails/WebsiteURLSecrion';

import AccessibilityViolationsList from '../../Components/ScanDetails/AccessibilityViolationsList';

import { groupDataMainPropTypes, requestDataProptype } from '../../PropTypes/ScanningScreenPropType';
import useWindowSize from '../../Helpers/useWindowSize';


//import ViolationsGroupListPlaceholder from '../../Components/Placeholder/ViolationsGroupList';
import ReactGA from "react-ga4";


import CustomLoader from '../../Components/CustomLoader';
import CustomHeader from '../../Components/CustomHeader';
import Footer from '../../Components/Footer';
import logo from "../../Assets/img/accessibility-checker-logo.svg";
import errorImage from "../../Assets/img/error-image.svg";
import DownloadReport from '../../Components/DownloadReport';
import AllInOneAccessibilityCTA from '../../Components/AllInOneAccessibilityCTA';
import aioaBanner from "../../Assets/img/AIOA-Banner-3.webp";
import manualBanner from "../../Assets/img/Manual-Accessibility-Audit-Report.webp";
import { BACKGROUNDCOLOR, IS_FROM_SCRIPT, LOADING, PID, PID_API_LOADING, SET_LANGUAGE, SET_STANDARD, SET_TOKEN, TEXTCOLOR, TITLE, WEBSITE_URL } from '../../Actions/Types';
import decodeBase64 from '../../Helpers/decodeBase64';
import { GetPartnerCheckerDetailsService } from '../../Services/GetPartnerCheckerDetailsService';



interface tempGropScorePropType {
  [keyname: string]: number[];
}
interface finalGropTotalScorePropType {
  [keyname: string]: number;
}

// component to render all in one promotional banner
const AIOAPromoBanner = () => {
    return (
        <div className="aioa-promo-banner" role="region" aria-label="Promotional banner for All in One Accessibility®. Learn more or try free.">
            <a href="https://ada.skynettechnologies.us/trial-subscription" target="_blank" aria-label="Start free trial">
                <img src={aioaBanner} alt="" className="img-fluid" />
            </a>
        </div>
    )
}

// component to render manual accessibility audit promo banner
const ManualAuditBanner = () => {
    return (
        <div className="aioa-promo-banner">
            <a href="https://www.skynettechnologies.com/website-accessibility-audit" target="_blank">
                <img src={manualBanner} alt="Manual Accessibility Audit" className="img-fluid" />
            </a>
        </div>
    )
}

function getWebsiteName(url:string) {
    // Remove protocol (http://, https://)
    let domain = url.replace(/^https?:\/\//, '');
    
    // Remove www.
    domain = domain.replace(/^www\./, '');
    
    // Get everything before the first slash or question mark
    domain = domain.split('/')[0];
    domain = domain.split('?')[0];
    
    return domain;
}

const Home = () => {

  ReactGA.initialize("G-85C9EMDGMJ", {
    gaOptions: {
      debug_mode: true,
    },
    gtagOptions: {
      debug_mode: true,
    },
  });

  const { scaningProcess, scaningProcessPer, websiteURL, reScaningProcess, isLoading, isPaidFree, pid, lang, title, ispidLoading, standard } = useSelector((store: StoreProptypes) => store);
  const [isFromScript, setIsFromScript] = useState<boolean>(false)
  const dispatch = useDispatch();

  const { windowWidth } = useWindowSize();


  const { t, i18n } = useTranslation();

  const [searchParams] = useSearchParams();
  const websiteURLParam = searchParams.get("website");
  
  const [isWhiteLabel, setIsWhiteLabel] = useState<boolean>(false)

  const changeLanguage = (
        langCode: string // language code
    ) => {
        i18n.changeLanguage(langCode);
        if (langCode !== lang) {
            dispatch({ type: SET_LANGUAGE, payload: langCode });
        }
    }


  useEffect(() => {
    if (websiteURLParam) {
      const urlParams = new URLSearchParams(window.location.search);
      const tokens = urlParams.get('token');
      if (tokens) {
        dispatch({ type: SET_TOKEN, payload: urlParams.get('token') })
        const decodeString = decodeBase64(tokens.toString())
        if (decodeString) {
          const params = new URLSearchParams(decodeString);
          const key = "is_white_label";
          setIsWhiteLabel(params.get(key) === 'true')
          const lang = params.get("langCode");
          if (lang) {
            changeLanguage(lang);
          }
          dispatch({ type: PID, payload: params.get("pId") })
          const standard = params.get("standard");
          if (standard) {
            dispatch({ type: SET_STANDARD, payload: params.get("standard") })
          }
          console.log('params.get("pId"): ', isWhiteLabel);
          if (params.get("isFromScript") === 'true') {
            setIsFromScript(true)
            dispatch({ type: IS_FROM_SCRIPT, payload: true })
          } else {
            setIsFromScript(false)
            dispatch({ type: IS_FROM_SCRIPT, payload: false })
          }
          if (params.get("pId") !== '' && params.get("pId") !== null) {
            dispatch({ type: PID_API_LOADING, payload: true })
            GetPartnerCheckerDetailsService(params.get("pId") || '').then((res:any) => {
              if (res?.style) {
                const styleTag = document.createElement("style");
                styleTag.innerHTML = res?.style;
                document.head.appendChild(styleTag);
              } else {
                if (res?.background_color) {
                  dispatch({ type: BACKGROUNDCOLOR, payload: res?.background_color })
                  const custom_color_style = document.createElement('style');
                  custom_color_style.id = "accessibility_checker_primary_color";

                  custom_color_style.textContent = `
                    :root {
                      --accessibility-checker-primary-color: ${res?.background_color};
                    }
                  `;

                  document.head.appendChild(custom_color_style);
                }
              }
              if (res?.title !== '') {
                dispatch({ type: TITLE, payload: res?.title })
              }
            }).catch(() =>{

            }).finally(() => {
              dispatch({ type: PID_API_LOADING, payload: false })
            })
          }

          const html = document.documentElement;
          if (html) {
              html.classList.add('isWhiteLabel');
          }
          
          console.log('Token found:', isWhiteLabel);
        }
      } else {
        console.log('No token in URL');
      }
      
      dispatch({ type: WEBSITE_URL, payload: websiteURLParam.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '') })
      //ScanningProcessService((), 2, i18n.language, dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall);
      //console.log("API Call websiteURLParam ==>", websiteURLParam)
    }
  }, [websiteURLParam]);

  useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const tokens = urlParams.get('token');
      if (tokens) {
        dispatch({ type: SET_TOKEN, payload: urlParams.get('token') })
        const decodeString = decodeBase64(tokens.toString())
        if (decodeString) {
          const params = new URLSearchParams(decodeString);
          const key = "is_white_label";
          setIsWhiteLabel(params.get(key) === 'true')
          dispatch({ type: PID, payload: params.get("pId") })
          const standard = params.get("standard");
          if (standard) {
            dispatch({ type: SET_STANDARD, payload: params.get("standard") })
          }
          const lang = params.get("langCode");
          if (lang) {
            changeLanguage(lang);
          }
           if (params.get("isFromScript") === 'true') {
            setIsFromScript(true)
            dispatch({ type: IS_FROM_SCRIPT, payload: true })
          } else {
            setIsFromScript(false)
            dispatch({ type: IS_FROM_SCRIPT, payload: false })
          }

          if (params.get("pId") !== '' && params.get("pId") !== null) {
            dispatch({ type: PID_API_LOADING, payload: true })
            GetPartnerCheckerDetailsService(params.get("pId") || '').then((res:any) => {
              if (res?.style) {
                const styleTag = document.createElement("style");
                styleTag.innerHTML = res?.style;
                document.head.appendChild(styleTag);
              } else {
                if (res?.background_color) {
                  dispatch({ type: BACKGROUNDCOLOR, payload: res?.background_color })
                 const custom_color_style = document.createElement('style');
                  custom_color_style.id = "accessibility_checker_primary_color";

                  custom_color_style.textContent = `
                    :root {
                      --accessibility-checker-primary-color: ${res?.background_color};
                    }
                  `;

                  document.head.appendChild(custom_color_style);
                }
              }
              if (res?.title !== '') {
                dispatch({ type: TITLE, payload: res?.title })
              }
            }).catch(() =>{

            }).finally(() => {
              dispatch({ type: PID_API_LOADING, payload: false })
            })
          }

          const html = document.documentElement;
          if (html) {
              html.classList.add('isWhiteLabel');
          }

        }
      } else {
        console.log('No token in URL');
      }
  }, [])

  useEffect(() => {
    if (websiteURL) {
      setScreenError(false)
      ScanningProcessService(websiteURL, 2, i18n.language, dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall, pid, isFromScript);
    }

  }, [websiteURL, standard])

  console.log("title", title);
  

  // Scan Result

  const [apiRecall, setApiRecall] = useState(false);

  const [fixedByWidget, setFixedByWidget] = useState(false);

  const [violationsGroupList, setViolationsGroupList] = useState<groupDataMainPropTypes>();

  const [filteredviolationsGroupList, setFilteredViolationsGroupList] = useState<groupDataMainPropTypes>();
  const [requestDataObj, setRequestDataObj] = useState<requestDataProptype>();

  const [errorViolationsTotal, setErrorViolationsTotal] = useState<number>(0);
  const [successViolationsTotal, setSuccessViolationsTotal] = useState<number>(0);
  const [errorViolationsTotalFixedByWidget, setErrorViolationsTotalFixedByWidget] = useState<number>(0);

  const [accessibilitySystemDetected, setAccessibilitySystemDetected] = useState<string>('');

  const [screenError, setScreenError] = useState<boolean>(false);
  const [fullScreenLoading, setFullScreenLoading] = useState<boolean>(false);



  useEffect(() => {
      // check if loading is active
      if (ispidLoading) {
          setFullScreenLoading(true);
      } else {
          setFullScreenLoading(false);
      }
  }, [ispidLoading])

  useEffect(() => {
    if (violationsGroupList) {
      setFilteredViolationsGroupList(violationsGroupList);
    }

  }, [violationsGroupList])

  const demoFunction = () => {
    /* console.log("demo function");
    console.log("scaningProcess", scaningProcess);
    console.log("websiteURL", websiteURL);
    console.log("scaningProcessPer", scaningProcessPer); */
    if (scaningProcess && websiteURL && scaningProcessPer !== 100) {
      ScanningProcessService(websiteURL, 1, i18n.language, dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall, pid, isFromScript);
    }
  }

  useEffect(() => {
    if (reScaningProcess && !scaningProcess) {
      setApiRecall(false);
    }
  }, [reScaningProcess, scaningProcess])

  useEffect(() => {
    if (apiRecall) {
      /* console.log("apiRecall use effect"); */
      setApiRecall(false);
      setTimeout(demoFunction, 2000);
      window.parent.postMessage({type: "IS_LOADER_SHOW"}, "*");
    }
  }, [apiRecall])



  // Accessibility Score

  const [accessibilityScore, setAccessibilityScore] = useState<number | null>(null);
  const [groupAccessibilityScore, setGroupAccessibilityScore] = useState<tempGropScorePropType>();
  const [finalGroupAccessibilityScore, setFinalGroupAccessibilityScore] = useState<finalGropTotalScorePropType>();

  useEffect(() => {
    if (violationsGroupList) {
      let keyObjScore: tempGropScorePropType = {};
      Object.keys(violationsGroupList).map((keyname) => {
        violationsGroupList[keyname].map((violation) => {
          let tempScore;
          if (fixedByWidget && violation.is_fixed_by_widget) {
            tempScore = 100;
            const tempObjValue = keyObjScore[keyname] ? { [keyname]: [...keyObjScore[keyname], tempScore] } : { [keyname]: [tempScore] }
            keyObjScore = { ...keyObjScore, ...tempObjValue }
          }
          else {
            if (violation.total_error > 0 || violation.total_success > 0) {
              if (violation.total_success > 0) {
                tempScore = parseInt(((violation.total_success / (violation.total_success + violation.total_error)) * 100).toFixed(2));
              } else {
                tempScore = 0;
              }
              const tempObjValue = keyObjScore[keyname] ? { [keyname]: [...keyObjScore[keyname], tempScore] } : { [keyname]: [tempScore] }
              keyObjScore = { ...keyObjScore, ...tempObjValue }
            }
            /*  else{ 
               tempScore = 100;
             } */

          }
        })
      })
      setGroupAccessibilityScore(keyObjScore);
    }
  }, [violationsGroupList, fixedByWidget])


  // Grop Score
  useEffect(() => {
    if (groupAccessibilityScore) {
      console.log("groupAccessibilityScore", groupAccessibilityScore);
      let tempObj: finalGropTotalScorePropType = {}
      Object.keys(groupAccessibilityScore).map((keyname, gIndex) => {
        const sum = groupAccessibilityScore[keyname].reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0);
        const persentage = sum / groupAccessibilityScore[keyname].length;
        tempObj = { ...tempObj, [keyname]: persentage }
      })
      setFinalGroupAccessibilityScore(tempObj);
    }
  }, [groupAccessibilityScore])


  useEffect(() => {
    if (finalGroupAccessibilityScore) {
      console.log("finalGroupAccessibilityScore", finalGroupAccessibilityScore);
      let sum = 0;
      Object.keys(finalGroupAccessibilityScore).map((keyname, gIndex) => {
        sum = sum + finalGroupAccessibilityScore[keyname];
      })
      const persentage = sum / Object.keys(finalGroupAccessibilityScore).length;
      setAccessibilityScore(persentage);
    }
  }, [finalGroupAccessibilityScore]);



  /* useEffect(() => {
    if (errorViolationsTotal > 0 && successViolationsTotal > 0) {
      let score = 0;
      if (fixedByWidget) {
        score = (successViolationsTotal + errorViolationsTotalFixedByWidget) / (errorViolationsTotal + successViolationsTotal) * 100;
      }
      else {
        score = successViolationsTotal / (errorViolationsTotal + successViolationsTotal) * 100;
      }
      setAccessibilityScore(score);
    }
    else if (errorViolationsTotal === 0 && successViolationsTotal > 0) {
      setAccessibilityScore(100);
    }
    else if (errorViolationsTotal > 0 && successViolationsTotal === 0) {
      setAccessibilityScore(0);
    }

  }, [successViolationsTotal, errorViolationsTotal, errorViolationsTotalFixedByWidget, fixedByWidget]) */


  interface ForwardedRefs {
    scoreRef: React.RefObject<HTMLDivElement>;
    wcagRef: React.RefObject<HTMLDivElement>;
  }

  const forwardedRefs = useRef<ForwardedRefs>({
    scoreRef: useRef<HTMLDivElement>(null),
    wcagRef: useRef<HTMLDivElement>(null),
  });

  const [scoreImage, setScoreImage] = useState<string>('');
  const [wcagImage, setWCAGImage] = useState<string>('');



  const GetScreenshot = () => {
    console.log("GetScreenshot called");
    console.log("ref.current", forwardedRefs.current.scoreRef.current);
    if (forwardedRefs.current.scoreRef.current === null || forwardedRefs.current.wcagRef.current === null) {
      return
    }


    toPng(forwardedRefs.current.scoreRef.current, { cacheBust: true, })
      .then((dataUrl) => {
        /* const link = document.createElement('a')
        link.download = 'my-image-name.png'
        link.href = dataUrl
        link.click() */
        setScoreImage(dataUrl);
      })
      .catch((err) => {
        console.log(err)
      });

    toPng(forwardedRefs.current.wcagRef.current, { cacheBust: true, })
      .then((dataUrl) => {
        /* const link = document.createElement('a')
        link.download = 'my-image-name1.png'
        link.href = dataUrl
        link.click() */
        setWCAGImage(dataUrl);
      })
      .catch((err) => {
        console.log(err)
      })
  }


  useEffect(() => {
    if (violationsGroupList && websiteURL) {
      ScanningProcessService(websiteURL, 1, i18n.language, dispatch, setViolationsGroupList, setErrorViolationsTotal, setErrorViolationsTotalFixedByWidget, setSuccessViolationsTotal, setAccessibilitySystemDetected, setRequestDataObj, setScreenError, setApiRecall, pid, isFromScript);
    }
  }, [i18n.language])

  function getHeadline(title:string) {
    if (title && title.trim() !== '') {
      return title;
    }

    return (
      <>
        <Trans i18nKey='landing-headline'>  
          Our free <h1>ADA and WCAG compliance checker</h1>
          identifies web accessibility issues
        </Trans> 
      </>
    );
  }



  //const [ipAddress, setIpAddress] = useState('');
  //const [countryCode, setCountryCode] = useState('');

  /* useEffect(() => {
    axios.get('https://ipapi.co/json/')
      .then(response => {
        const ipData = response.data;
        setIpAddress(ipData.ip);
        //setCountryCode(ipData.country_code);
      })
      .catch(error => console.error(error));
  }, []); */

  return (
    <>
      {fullScreenLoading && (
        <>
          <div role="alert" className="aioa_checker-fullscreen-loader" aria-live='polite'>
              <div className="aioa_checker-loader">
                  <img src={LodingImg} alt="" />
                  <span className="visually-hidden">{t("Loading page. Please Do not refresh the page")} </span>
              </div>
          </div>
        </>
      )}
      <MainTemplate>
        
        <MetaDataProivder />


        <div className={`page-content show-lang`}>
        {/* <div className={`page-content ${ipAddress === '59.97.182.246' ? 'show-lang' : ''}`}> */}

          {screenError ? (
            <>
              <div className="error-page-wrapper">
                <Container>
                    <div className='logo-wrapper'>
                      <img src={logo} alt={t('logo-alt-text')} />
                    </div>
                  <div className='graphics-form-wrapper'>
                    <div className='error-image-wrapper'>
                      <img src={errorImage} alt="" />
                    </div>
                    <div className='error-text-form-wrapper text-center'>
                      <h2 className='h1'>{t("Website Connection Error")}</h2>
                      <p>
                        <Trans components={{ br: <br />, a: <a /> }}>{t('Connection Error Message')}</Trans>
                      </p>
                      <ScanURLFormComponents />
                    </div>
                  </div>
                </Container>
                <Container className='report-a-problem-link'>
                  <Link to="/report-a-problem">{t("Report a Problem")}</Link>
                </Container>
              </div>
            </>
          ) : (
            <>
              {!scaningProcess && !reScaningProcess ? (
                <>
                  <Container fluid className="landing-page-wrapper">
                    <Row className="h-100">
                      {!isWhiteLabel && (
                        <>
                          {windowWidth > 1560 ?
                            <Col className="hero-image-wrapper d-flex align-items-center justify-content-center p-5">
                              <img src={heroImage} alt=''/>
                            </Col>
                            : <></>
                          }
                        </>
                      )}

                      <Col className={`${windowWidth > 1560 ? 'd-flex' : ''}`}>
                        <div className={`left-wrapper ${isWhiteLabel ? 'w-100' : ''}`}>
                          <CustomHeader isWhiteLabel={isWhiteLabel}/>
                          <main className="form-wrapper">
                            <Container>
                              <div className='heading'>
                                {getHeadline(title)}
                              </div>
                              <ScanURLFormComponents isWhiteLabel={isWhiteLabel}/>


                            </Container>

                          </main>
                          {!isWhiteLabel && (
                            <Footer />
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </>
              ) : (
                <>

                  {filteredviolationsGroupList && (accessibilityScore !== null) && !isLoading ? (
                    <>
                      <div className="page-content-inner">
                        {/* {fixedByWidget ? <div className="star-background">
                          <div className="flash"></div>
                        </div>
                          : <></>
                        } */}

                        <div className='scan-details-page-main'>
                          <CustomHeader isWhiteLabel={isWhiteLabel}/>
                          <main>
                            <div className='light-bg pb-4 pb-lg-5'>
                              {websiteURL ? <>
                                <div className='report-url-pdf-section'>
                                  <Container>
                                    <h1 className='url'>
                                      <Trans
                                        i18nKey="Accessibility report for"
                                        defaults="Accessibility report for <bold>{{- website}}</bold>"
                                        values={{
                                          website: getWebsiteName(websiteURL) ?? websiteURL,
                                        }}
                                        components={{
                                          bold: <strong />,
                                        }}
                                      />
                                    </h1>
                                    {requestDataObj ? <DownloadReport requestDataObj={requestDataObj} GetScreenshot={GetScreenshot} scoreImage={scoreImage} wcagImage={wcagImage} isWhiteLabel={isWhiteLabel}/> : <></>}
                                  </Container>
                                </div>
                              </> : <></>}

                              {requestDataObj ? <>

                              </> : <></>}
                              {(accessibilityScore !== null) ? <>
                                <WebsiteURLSection
                                  accessibilitySystemDetected={accessibilitySystemDetected}
                                  accessibilityScore={accessibilityScore}
                                  errorViolationsTotal={errorViolationsTotal}
                                  errorViolationsTotalFixedByWidget={errorViolationsTotalFixedByWidget}
                                  fixedByWidget={fixedByWidget}
                                  setFixedByWidget={setFixedByWidget}
                                  ref={forwardedRefs}
                                  isWhiteLabel={isWhiteLabel}
                                />
                              </> : <></>}


                            </div>
                            <Container>

                              {requestDataObj ?
                                <AccessibilityViolationsList
                                  fixedByWidget={fixedByWidget}
                                  violationsGroupList={filteredviolationsGroupList}
                                  isWhiteLabel={isWhiteLabel}
                                />
                                : <></>
                              }
                              {/* {!isWhiteLabel && (

                                <div className='site-footer'>

                                  {(accessibilitySystemDetected !== '' && accessibilitySystemDetected !== null && accessibilitySystemDetected !== "All in One Accessibility™") ?
                                    <AllInOneAccessibilityCTA />
                                    : (
                                      <>
                                        {isPaidFree ? (
                                          <>
                                            {isPaidFree === 2 ? <>

                                            </> : <>
                                              <AllInOneAccessibilityCTA />
                                            </>}

                                          </>
                                        ) : (
                                          <>
                                            <AllInOneAccessibilityCTA />
                                          </>
                                        )}
                                      </>
                                    )}



                                  <div className="cts-box">
                                    <div className="cts-box-text">
                                      <h2 className="h3 mb-3">{t("Manual Accessibility Audit Title")}</h2>
                                      <p>{t("Manual Accessibility Audit Description")}</p>
                                    </div>
                                    <div className="cts-box-btn">
                                      <a href="https://www.skynettechnologies.com/website-accessibility-audit" className="btn btn-light" target='_blank'>
                                        <span>{t("Request Manual Accessibility Audit")}</span>
                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 9.5 16">
                                          <path d="M1.5,0L0,1.5L6.5,8L0,14.5L1.5,16l8-8L1.5,0z"></path>
                                        </svg>
                                      </a>
                                    </div>
                                  </div>

                                </div>
                              )} */}


                              {(accessibilitySystemDetected !== ''
                              && accessibilitySystemDetected !== null
                              && accessibilitySystemDetected !== "All in One Accessibility™") // check if all in one accessibility is detected
                              ?
                              <>
                                  {!isWhiteLabel && (
                                      <ManualAuditBanner />
                                  )}
                              </>
                              : (
                                  <>
                                      {isPaidFree ? // check if widget flag is available
                                          (
                                              <>
                                                  {isPaidFree === 2 // check if widget paid
                                                      ? <>
                                                          {!isWhiteLabel && (
                                                              // <ScanningMonitoringPromoBanner />
                                                              <ManualAuditBanner />
                                                          )}
                                                      </> : <>
                                                          {!isWhiteLabel && (
                                                              <AIOAPromoBanner />
                                                          )}
                                                      </>}

                                              </>
                                          ) : (
                                              <>
                                                  {!isWhiteLabel && (
                                                      <AIOAPromoBanner />
                                                  )}
                                              </>
                                          )}
                                  </>
                              )}
                              {!isWhiteLabel && (
                                <div className="accessibility-consult-box">
                                  <div className="consult-text">
                                    <h3>Looking for expert help to resolve these accessibility issues?</h3>
                                    <p>
                                      Our team can assist in making your website meet compliance standards. We’ll review this report, create a clear action plan, and support your team in achieving <strong>WCAG AA (2.1/2.2)</strong> and <strong>EAA</strong> compliance.
                                    </p>
                                    <ul>
                                      <li>✔ Comprehensive manual review and assistive technology testing</li>
                                      <li>✔ Accessibility statement with supporting documentation</li>
                                      <li>✔ Transparent pricing and dedicated support options</li>
                                    </ul>
                                  </div>
                                  <div className="consult-action">
                                    <a href="https://www.skynettechnologies.com/full-website-accessibility-remediation#consultationform" target='_blank' className="consult-btn">
                                    Schedule a Call
                                    </a>
                                  </div>
                                </div>
                              )}


                            </Container>

                          </main>
                          {!isWhiteLabel && (
                            <div className='mt-5'>
                              <Footer />
                            </div>
                          )}
                        </div>
                      </div>

                    </>
                  ) : (
                    <>
                      <CustomLoader isWhiteLabel={isWhiteLabel}/>
                    </>
                  )}



                </>
              )}
            </>
          )}

        </div>

      </MainTemplate >
    </>
  )

}

export default Home;